module.exports = __webpack_public_path__ + "graphics/11.ckh.e90ba0d1fbef585f997546486888a807.png";